export interface TransportLeg {
  mode: "bus" | "train" | "flight";
  provider?: string;
  providerName?: string;
  providerImage?: string;
  departureTime: string;
  arrivalTime: string;
  cost?: number;
  origin?: string;
  destination?: string;
  originCode?: string;
  destinationCode?: string;
  originTimezone?: string;
  destinationTimezone?: string;
}

export interface TransportLegFormData {
  mode: "flight" | "train" | "bus";
  departureTime: string;
  arrivalTime: string;
  cost: number;
  origin: string;
  destination: string;
  provider?: string;
  providerName?: string;
  providerImage?: string;
  originCode?: string;
  destinationCode?: string;
  originCoordinates?: {
    latitude: number;
    longitude: number;
  };
  destinationCoordinates?: {
    latitude: number;
    longitude: number;
  };
  originTimezone?: string;
  destinationTimezone?: string;
}

export interface TransportFormData {
  numberOfLegs: string | number;
  legs: TransportLegFormData[];
}

export interface LocationInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const transportProviders = {
  flight: [
    { id: "united", name: "United Airlines", logo: "UA" },
    { id: "delta", name: "Delta Airlines", logo: "DL" },
    { id: "american", name: "American Airlines", logo: "AA" },
  ],
  train: [
    { id: "amtrak", name: "Amtrak", logo: "AM" },
    { id: "eurostar", name: "Eurostar", logo: "EU" },
  ],
  bus: [
    { id: "greyhound", name: "Greyhound", logo: "GH" },
    { id: "flixbus", name: "FlixBus", logo: "FB" },
  ],
};
